var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeafFilled = function SvgLeafFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.559 17.721a.435.435 0 0 1-.212-.113c-2.576-2.49-3.035-6.178-1.061-8.804a8.035 8.035 0 0 1 3.086-2.507c.932-.44 1.784-.693 3.399-1.074l.204-.048c3.188-.75 4.495-1.325 5.82-2.951a.438.438 0 0 1 .748.119c1.72 4.475.969 8.839-2.31 12.517-1.455 1.632-3.884 2.838-5.911 3.213a7.156 7.156 0 0 1-.197.052c-1.454.363-2.88-.071-3.566-.404Zm-.373 3.812a.438.438 0 0 1-.872-.066c.199-2.637.982-4.912 2.301-6.982 1.054-1.652 2.349-3.065 4.245-4.78.34-.306 2.318-2.04 2.843-2.526a.438.438 0 0 1 .594.642c-.535.495-2.518 2.234-2.85 2.534-3.992 3.607-5.917 6.627-6.26 11.178Z"
  })));
};
export default SvgLeafFilled;